/**
 *
 * @module storage
 * @desc Storage provider entry point, determines proper implementation to load
 * based on device family and the current application runtime.
 * @see https://github.bamtech.co/fed-core/browser-sdk/blob/master/docs/DeploymentProfiles.md
 *
 */

const deviceFamily = process.env.device_family;
const applicationRuntime = process.env.application_runtime;

let strategy = 'isomorphic';

if (deviceFamily === 'apple') {
    strategy = deviceFamily;
}

if (applicationRuntime === 'orsay') {
    strategy = `${deviceFamily}/${applicationRuntime}`;
}

if (applicationRuntime === 'trilithium') {
    strategy = `${deviceFamily}/${applicationRuntime}`;
}

export default require(`./${strategy}/storage`);



// WEBPACK FOOTER //
// ./src/services/platforms/storage.js